/**
 * Serving multiple ads in the same js context,
 * we needed to externalize this timeout.
 *
 * A timeout is set when the slide-up didFinishAnimation property is true.
 * Once that timeout expires, it calls a callback.
 */
export default class CloseGate {
  constructor(window) {
    this.window = window;
    this.appDisplayingTimeout = null;
    this.engagementDisplayingTimeout = null;
    this.closeEnabled = false;
  }

  /**
   * This gives us a backstop of 10s.
   * @param callback
   */
  appDisplaying(callback) {
    if (this.appDisplayingTimeout || this.engagementDisplayingTimeout) {
      console.log('CloseGate appDisplayingTimeout OR engagementDisplayingTimeout set, so doing nothing');
      return;
    }
    console.log('CloseGate appDisplayingTimeout setting timeout');
    const self = this;
    this.appDisplayingTimeout = this.window.setTimeout(() => {
      console.log('CloseGate appDisplayingTimeout firing.  Enabling close.');
      self.closeEnabled = true;
      callback();
    }, 10000);
  }

  /**
   * Once the engagement has been displayed, they get 5s.
   * @param callback
   */
  engagementDisplaying(callback) {
    if (this.engagementDisplayingTimeout) {
      console.log('CloseGate engagementDisplayingTimeout already set');
      return;
    }
    if (this.appDisplayingTimeout) {
      console.log('CloseGate clearing appDisplayingTimeout');
      this.window.clearTimeout(this.appDisplayingTimeout);
    }
    console.log('CloseGate engagementDisplayingTimeout setting timeout');
    const self = this;
    this.engagementDisplayingTimeout = this.window.setTimeout(() => {
      console.log('CloseGate engagementDisplayingTimeout firing.  Enabling close.');
      self.closeEnabled = true;
      callback();
    }, 5000);
  }

  closeClicked(callback) {
    console.log('CloseGate closeClicked setting interval');
    const self = this;
    const checkInterval = this.window.setInterval(() => {
      if (self.closeEnabled) {
        console.log('CloseGate closeClicked firing.  with close enabled.');
        this.window.clearInterval(checkInterval);
        callback();
      } else {
        console.log('CloseGate closeClicked firing.  without close enabled.');
      }
    }, 250);
  }
}
